/* eslint-disable array-callback-return */
/* eslint-disable no-unused-vars */
/*global kakao*/

import React, { Component, PureComponent, Fragment } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import axios from 'axios';

import StoreLeftMenu from '../../menu/StoreLeftMenu';
import Footer from '../../components/Footer';

import $ from 'jquery';
import '../../slick.js';
//import '../../loadmap.js'

import ColraboCafeItem from '../../components/store/ColraboCafeItem';
import Slider from 'react-slick';

import StoreInfoHapjungItem from '../../components/store/StoreInfoHapjungItem';
import StoreInfoDaejeonItem from '../../components/store/StoreInfoDaejeonItem';
import StoreInfoGwangjuItem from '../../components/store/StoreInfoGwangjuItem';
import StoreInfoBusanItem from '../../components/store/StoreInfoBusanItem';
import StoreInfoMap from '../../components/store/StoreInfoMap';

import NaverBlogItem from '../../components/store/NaverBlogItem';
import StoreStoryItem from '../../components/store/StoreStoryItem';
import TwitterItem from '../../components/store/TwitterItem';
import EventItem from '../../components/store/EventItem';
import StoreInfoStoryList from './StoreInfoStoryList';

import parse from 'html-react-parser';

import moment from 'moment';

class StoryInfo extends PureComponent {
  state = {
    slideIndex: 0,
    slidePlay: true,
    bannerList: [],
    gotoPage: 1,
    pageSize: 20,
    pageCount: 0,
    con: 0,
    allList: [],
    topList: [],
    bottomList: [],
  };
  _isLoad = false;
  componentDidMount = () => {
    this._isLoad = true;
    const { match } = this.props;
    const store = match.params.store;
    //console.log(store)

    setTimeout(() => {
      //alert(1)
      $('.big_item .inner_item').stick_in_parent({
        parent: '.store_card_list',
      });
    }, 2500);

    this._getColraboBanner(
      store
    ); /*지점별 콜라보 베너(관리자 배너 등록에서 등록)*/
    this._getEventBanner(store);
    // this._getTwitter(store);

    window.onload = function () {
      $('.big_item .inner_item').stick_in_parent({
        parent: '.store_card_list',
      });
    };
    this._getData(store, 1);
    //this._getBlog(store)
    //this._getStoreStory(store)

    window.addEventListener('popstate', (event) => {
      setTimeout(() => {
        $('.big_item .inner_item').stick_in_parent({
          parent: '.store_card_list',
        });
      }, 1200);
    });

    /*
        $('.btn_left_navi').on("click", (function(){
            $('.vod_list_left').toggleClass('left_naviVisible');
            $('.theme_lt .quick').toggleClass('left_navi');
        }))

        //스크롤 고정 플러그인 사용
        $('.big_item .inner_item').stick_in_parent({
            parent: '.store_card_list'
        });
        */

    //매장 정보 슬라이드
    /*
        $('.store_info_slide').slick({
            slide: '.store_info_img',
            slidesToShow: 1,
            slidesToScroll: 1,
            fade: true,
            infinite : true,
            autoplay: true,
            autoplaySpeed: 5000,
            prevArrow: false,
            nextArrow: false,
            dots: true
        })
        //매장정보 평면도 슬라이드 이동 버튼
        $('.store_plan .map a').on("click", (function(e) {
            var slideno = $(this).data('slide');
            $('.store_info_slide').slick('slickGoTo', slideno - 1);
        }));
        //매장정보 평면도 슬라이드 매핑
        $('.store_info_slide').on('afterChange', function(event, slick, currentSlide){   
            if ($('.store_info_img').hasClass('slick-current')){
                var floorCurrent = $('.store_plan .map a[data-slide=' + (currentSlide + 1) + ']').data('floor-plan');
                $('.floor_plan').attr('src', '/img/store/info_' + floorCurrent + '.png');
            }
        });
         //매장 정보 평면도 클릭 시 이미지 변경 - 즉각 반응 위해 추가
         $('.store_plan .map a').on("click", (function () {
            var floorPlan = $(this).data('floor-plan');
            $('.floor_plan').attr('src', '/img/store/info_' + floorPlan + '.png');
        }));
        */
    //콜라보 슬라이드
    /*
        setTimeout(()=>{
            $('.store_collabo_slide').slick({
                slide: '.collabo_slide_item',
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite : true,
                autoplay: true,
                autoplaySpeed: 5000,
                prevArrow: false,
                nextArrow: false,
                dots: false,
                speed: 1000  
            })
            //콜라보 슬라이드 이동 버튼
            $('.collabo_slide_btn .link').click(function(e) {
                var slideno = $(this).data('slide');
                $('.store_collabo_slide').slick('slickGoTo', slideno - 1);
            });
            //콜라보 슬라이드 매핑
            $('.store_collabo_slide').on('afterChange', function(event, slick, currentSlide){   
                if ($('.collabo_slide_item').hasClass('slick-current')){
                    var collaboCurrent = $('.collabo_slide_btn .link[data-slide=' + (currentSlide + 1) + ']');
                    $('.collabo_slide_btn .link').removeClass('active');
                    $(collaboCurrent).addClass('active');
                }
            });
        }, 3000)
        */

    /*
        new daum.roughmap.Lander({
            "timestamp" : "1642503370704",
            "key" : "28uh2",
            "mapWidth" : "1426",
            "mapHeight" : "635"
        }).render();
        */
  };
  componentWillUnmount = () => {
    this._isLoad = false;
  };
  UNSAFE_componentWillReceiveProps = (nextProps, nextState) => {
    ////console.log(this.props.location.pathname)
    ////console.log(nextProps.location)
    return this.props.match.params.store !== nextProps.match.params.store;
    //return true;
  };
  componentWillReceiveProps = (nextProps) => {
    //console.log(this.props.match.params.store)
    //console.log(nextProps.match.params.store)
    if (this.props.match.params.store !== nextProps.match.params.store) {
      if (this._isLoad) {
        this.setState({
          topList: [],
          bottomList: [],
        });
      }
      // this._getTwitter(nextProps.match.params.store);
      this._getColraboBanner(nextProps.match.params.store);
      //this._getData(nextProps.match.params.store, 1)

      this._getEventBanner(nextProps.match.params.store);
      this._getData(nextProps.match.params.store, 1);
      setTimeout(() => {
        //alert(0)
        $('.big_item .inner_item').stick_in_parent({
          parent: '.store_card_list',
        });
      }, 2000);
      //this._getBlog(nextProps.match.params.store)
    }
  };
  _getColraboBanner = async (store) => {
    //collabo
    const { match } = this.props;
    //const store = match.params.store;

    const result = await this._getColraboBannerApi(store);
    const intReturn = result.data[0].intReturn;
    const bannerList = result.data[0].listData;
    if (this._isLoad) {
      if (intReturn === 0) {
        this.setState({
          bannerList,
        });
      } else {
        this.setState({
          bannerList: [],
        });
      }
    }
  };
  _getColraboBannerApi = (store) => {
    const { apiUrl, loginId } = this.props;

    return axios
      .post(apiUrl + '/storeCollaboBannerNew', {
        params: {
          shop: store,
          userid: loginId,
        },
      })
      .then((response) => response)
      .catch((error) => {
        // alert("오류가 발생했습니다.");
      });
  };
  _getData = async (store, gotoPage) => {
    const result = await this._getDataApi(store, gotoPage);
    //console.log(result)
    const con = result.data[0].con;
    const pageCount = result.data[0].pageCount;
    const intReturn = result.data[0].intReturn;
    const storeList = result.data[0].listData;
    //console.log(storeList)
    if (intReturn === 0) {
      if (con > 0) {
        if (this._isLoad) {
          this.setState({
            //allList: this.state.allList.concat(storeList),
            bottomList: this.state.topList.concat(storeList),
            storeList,
          });
        }
        /*
                this.setState({
                    storeList: gotoPage === 1 ? storeList : this.state.storeList.concat(storeList),
                    con,
                    pageCount,
                    gotoPage
                })
                */
      } else {
      }
    }
  };
  _getDataApi = (store, gotoPage) => {
    const { apiUrl, loginId, match } = this.props;
    //const { idx, store } = this.props.childProps;
    //const store = match.params.store;
    const { pageSize } = this.state;
    //console.log(store)
    return axios
      .post(apiUrl + '/storeStoryList', {
        params: {
          board_id: 301,
          gotoPage: gotoPage,
          shop: store,
          pageSize: pageSize,
          loginId: loginId,
        },
      })
      .then((response) => response)
      .catch((error) => {
        // alert('오류가 발생했습니다.');
      });
  };
  _getBlog = async (store) => {
    //const { allList } = this.state;
    const result = await this._getBlogApi(store);
    const intReturn = result.data[0].intReturn;
    const blogList = result.data[0].listData;
    //console.log(blogList)
    if (intReturn === 0) {
      //allList.concat(blogList)

      blogList.map((item, index) => {
        item.gubun = 'blog';
      });
      //console.log(blogList)

      if (this._isLoad) {
        this.setState({
          bottomList: this.state.rightBottomList.concat(blogList),
          blogList,
        });
      }
    }
  };
  _getBlogApi = (store) => {
    const { apiUrl } = this.props;
    return axios
      .post(apiUrl + '/getNaverBlogStore', {
        params: {
          store: store,
        },
      })
      .then((response) => response)
      .catch((error) => {
        // alert('오류가 발생했습니다.');
      });
  };
  _getEventBanner = async (store) => {
    //collabo

    const result = await this._getEventBannerApi(store);
    const intReturn = result.data[0].intReturn;
    const eventBannerList = result.data[0].listData;

    if (intReturn === 0) {
      if (this._isLoad) {
        this.setState({
          topList: this.state.topList.concat(eventBannerList),
          eventBannerList,
        });
      }
    }
  };
  _getEventBannerApi = (store) => {
    const { apiUrl } = this.props;

    return axios
      .post(apiUrl + '/shop_event_banner', {
        params: {
          shop: store,
        },
      })
      .then((response) => response)
      .catch((error) => {
        // alert('오류가 발생했습니다.');
      });
  };
  _getTwitter = async (store) => {
    //const { allList } = this.state;

    const result = await this._getTwitterApi(store);
    //const result = await this._getBlogApi(store)
    const intReturn = result.data[0].intReturn;
    const twitterList = result.data[0].listData;
    //console.log(blogList)
    if (intReturn === 0) {
      //allList.concat(blogList)

      twitterList.map((item, index) => {
        //item.gubun = 'blog'
        item.gubun = 'twitter';
        item.postdate = moment(new Date(item.createat)).format('YYYYMMDD');
      });
      //console.log(twitterList)
      if (this._isLoad) {
        this.setState({
          //allList: this.state.allList.concat(twitterList),
          topList: this.state.topList.concat(twitterList),
          twitterList,
        });
      }
    }
  };
  _getTwitterApi = (store) => {
    const { apiUrl } = this.props;

    return axios
      .post(apiUrl + '/getTwitterLocal', {
        params: {
          store: store,
        },
      })
      .then((response) => response)
      .catch((error) => {
        // alert('오류가 발생했습니다.');
      });
  };
  _renderBanner = () => {
    const { bannerList } = this.state;

    const list = bannerList.map((item, index) => {
      return (
        <ColraboCafeItem
          key={index}
          idx={item.idx}
          bannerFile={item.bannerFile}
          LinkURL={item.LinkURL}
          Linktarget={item.Linktarget}
          title={item.title}
          comment={item.comment}
          image={item.image}
          LinkUrl_M={item.LinkUrl_M}
          Linktarget_M={item.Linktarget_M}
          adComIdx={item.adComIdx}
          pageCode={item.pageCode}
          openDay={item.openDay}
          openDay1={item.openDay1}
          likes={item.likes}
          isLike={item.isLike}
          comment_count={item.comment_count}
          readNum={item.readNum}
          pos={'cafe'}
        />
      );
    });

    return list;
  };
  _afterChange = (index, idx) => {};
  _beforChange = (current, next) => {
    //const { bannerList } = this.state
    //console.log('aaaa ==> ' + current)
    //if(current > 0) {
    //    console.log(bannerList[current].idx)
    //}
    if (this._isLoad) {
      this.setState({ slideIndex: next });
    }
  };
  _onNext = () => {
    this.slider.slickNext();
  };
  _onPrev = () => {
    this.slider.slickPrev();
  };
  _onGoto = (i) => {
    ////console.log(i)
    this.slider.slickGoTo(i);
  };

  _renderStoryItem = () => {
    const { storeList } = this.state;
    storeList.sort(function (a, b) {
      return b.postdate - a.postdate;
    });

    const list = storeList.map((item, index) => {
      return (
        <StoreStoryItem
          key={index}
          gubun={item.gubun}
          idx={item.idx}
          id={item.id}
          storeName={item.storeName}
          categoryName={item.categoryName}
          title={item.title}
          readnum={item.readnum}
          chuchon={item.chuchon}
          likes={item.likes}
          comment_num={item.comment_num}
          writeday={item.writeday}
          filename={item.filename}
          content={item.content}
          active={item.active}
        />
      );
    });

    return list;
  };
  _renderBlogItem = () => {
    const { blogList } = this.state;
    blogList.sort(function (a, b) {
      return b.postdate - a.postdate;
    });

    const list = blogList.map((item, index) => {
      return (
        <NaverBlogItem
          key={index}
          gubun={item.gubun}
          bloggerlink={item.bloggerlink}
          bloggername={item.bloggername}
          description={item.description}
          link={item.link}
          postdate={item.postdate}
          title={item.title}
        />
      );
    });

    return list;
  };

  _renderAllItem = () => {
    const { allList } = this.state;

    allList.sort(function (a, b) {
      return b.postdate - a.postdate;
    });

    /*gubun에 따라 컴포넌트 분기 시킬것!*/

    const list = allList.map((item, index) => {
      if (item.gubun === 'blog') {
        return (
          <NaverBlogItem
            key={index}
            gubun={item.gubun}
            bloggerlink={item.bloggerlink}
            bloggername={item.bloggername}
            description={item.description}
            link={item.link}
            postdate={item.postdate}
            title={item.title}
          />
        );
      } else if (item.gubun === 'story') {
        return (
          <StoreStoryItem
            key={index}
            gubun={item.gubun}
            idx={item.idx}
            id={item.id}
            storeName={item.storeName}
            categoryName={item.categoryName}
            title={item.title}
            readnum={item.readnum}
            chuchon={item.chuchon}
            likes={item.likes}
            comment_num={item.comment_num}
            writeday={item.writeday}
            filename={item.filename}
            content={item.content}
            active={item.active}
          />
        );
      }
    });
    return list;
  };
  _renderBottomItem = () => {
    const { bottomList } = this.state;

    bottomList.sort(function (a, b) {
      return b.postdate - a.postdate;
    });

    /*gubun에 따라 컴포넌트 분기 시킬것!*/

    const list = bottomList.map((item, index) => {
      if (item.gubun === 'blog') {
        return (
          <NaverBlogItem
            key={index}
            gubun={item.gubun}
            bloggerlink={item.bloggerlink}
            bloggername={item.bloggername}
            description={item.description}
            link={item.link}
            postdate={item.postdate}
            title={item.title}
          />
        );
      } else if (item.gubun === 'story') {
        return (
          <StoreStoryItem
            key={index}
            gubun={item.gubun}
            idx={item.idx}
            id={item.id}
            storeName={item.storeName}
            categoryName={item.categoryName}
            title={item.title}
            readnum={item.readnum}
            chuchon={item.chuchon}
            likes={item.likes}
            comment_num={item.comment_num}
            writeday={item.writeday}
            filename={item.filename}
            content={item.content}
            active={item.active}
          />
        );
      } else if (item.gubun === 'twitter') {
        return (
          <TwitterItem
            key={index}
            gubun={item.gubun}
            id={item.id}
            postdate={item.postdate}
            //source={item.source}
            text={item.text}
            media={item.media}
            store={this.props.match.params.store}
          />
        );
      } else if (item.gubun === 'event') {
        return (
          <EventItem
            key={index}
            idx={item.idx}
            bannerFile={item.bannerFile}
            LinkURL={item.LinkURL}
            Linktarget={item.Linktarget}
            title={item.title}
            comment={item.comment}
            banner={item.banner}
            LinkUrl_M={item.LinkUrl_M}
            Linktarget_M={item.Linktarget_M}
            adComIdx={item.adComIdx}
            pageCode={item.pageCode}
            gubun={item.gubun}
            comment_count={item.comment_count}
            openDay={item.openDay}
          />
        );
      }
    });
    return list;
  };
  _renderTopItem = () => {
    const { topList } = this.state;

    topList.sort(function (a, b) {
      return b.postdate - a.postdate;
    });

    /*gubun에 따라 컴포넌트 분기 시킬것!*/

    const list = topList.map((item, index) => {
      if (item.gubun === 'blog') {
        return (
          <NaverBlogItem
            key={index}
            gubun={item.gubun}
            bloggerlink={item.bloggerlink}
            bloggername={item.bloggername}
            description={item.description}
            link={item.link}
            postdate={item.postdate}
            title={item.title}
          />
        );
      } else if (item.gubun === 'story') {
        return (
          <StoreStoryItem
            key={index}
            gubun={item.gubun}
            idx={item.idx}
            id={item.id}
            storeName={item.storeName}
            categoryName={item.categoryName}
            title={item.title}
            readnum={item.readnum}
            chuchon={item.chuchon}
            likes={item.likes}
            comment_num={item.comment_num}
            writeday={item.writeday}
            filename={item.filename}
            content={item.content}
            active={item.active}
          />
        );
      } else if (item.gubun === 'twitter') {
        return (
          <TwitterItem
            key={index}
            gubun={item.gubun}
            id={item.id}
            postdate={item.postdate}
            //source={item.source}
            text={item.text}
            media={item.media}
            store={this.props.match.params.store}
          />
        );
      } else if (item.gubun === 'event') {
        return (
          <EventItem
            key={index}
            idx={item.idx}
            bannerFile={item.bannerFile}
            LinkURL={item.LinkURL}
            Linktarget={item.Linktarget}
            title={item.title}
            comment={item.comment}
            banner={item.banner}
            LinkUrl_M={item.LinkUrl_M}
            Linktarget_M={item.Linktarget_M}
            adComIdx={item.adComIdx}
            pageCode={item.pageCode}
            gubun={item.gubun}
            comment_count={item.comment_count}
            openDay={item.openDay}
          />
        );
      }
    });

    return list;
  };

  render() {
    const { match } = this.props;
    const store = match.params.store;
    const {
      bannerList,
      slideIndex,
      allList,
      topList,
      bottomList,
      storeList,
      blogList,
    } = this.state;
    var settings = {
      dots: false,
      //dotsClass: "slick-dots slick-thumb",
      infinite: true,
      //speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      autoplay: true,
      //speed: 3000,
      //className: 'slide_baner baner_group baner_div1',
      pauseOnFocus: true,
      //fade: true,
      adaptiveHeight: false,
      //centerMode: true,

      //variableWidth: true,
      beforeChange: (current, next) => this._beforChange(current, next),
      afterChange: (index) => this._afterChange(index),
    };
    console.log(storeList);
    return (
      <Fragment>
        <div className="content">
          {/* 220109 store/ */}
          {/* 왼쪽 메뉴 */}
          <StoreLeftMenu />

          {/* 오른쪽 콘텐츠 */}
          <div className="vod_list_right store_right">
            <div className="vod_list_group">
              <div className="store_wrap">
                {/* 스토어 상단 */}
                <div className="store_header">
                  <h1>
                    {store === 'hapjung'
                      ? '서울 합정점'
                      : store === 'daejeon'
                      ? '대전 중앙로점'
                      : store === 'gwangju'
                      ? '광주 충장로점'
                      : store === 'busan'
                      ? '부산 서면점'
                      : null}
                  </h1>
                  <div className="store_summary">
                    {store === 'hapjung'
                      ? parse(
                          '전국 애니메이션 팬 고객님들의 필수 방문 코스이자 직영점 중 최대 규모인 서울 합정점은<br/>최신 인기 작품들로 구성된 콜라보 카페 2곳이 언제나 여러분을 기다리고 있습니다.'
                        )
                      : store === 'daejeon'
                      ? parse(
                          '"영화보고 애플샵 한정메뉴 먹고 갈래?"<br/>2021년 8월 신규 오픈한 대전 중앙로점은 국내 애니플러스 오프라인 샵 2호점으로써, 메가박스와 같은 4층에 위치하며 애니메이션 극장판 관람과 함께 콜라보 카페를 가까운 곳에서 만나 보실 수 있습니다.'
                        )
                      : store === 'gwangju'
                      ? parse(
                          '애니플러스 유일 복층 구조인 광주 충장로점은<br/>1층은 다양한 굿즈를 구매할 수 있는 굿즈 샵,2층은 애니메이션 영상과 콜라보 메뉴를 즐길 수 있는 카페를 운영중이며, 직영 샵 최고의 카페 분위기를 자랑합니다.'
                        )
                      : store === 'busan'
                      ? parse(
                          '국내 최초, 인터렉티브존을 완비한 굿즈샵으로<br/>이색적인 체험을 할 수 있으며, 더블 콜라보 카페와 다양한 굿즈 판매를 통해 볼 거리, 즐길 거리를 모두 제공하고 있는 멀티형 매장입니다.'
                        )
                      : null}
                  </div>
                  <div className="store_top_link">
                    <a href="#store_info">매장 정보</a>
                    <a href="#store_collabo">콜라보 카페 & 이벤트</a>
                    <a href="#store_newsStory">매장 소식 & 이야기</a>
                    <a href="#store_location">오시는길</a>
                  </div>
                </div>

                {/* 스토어 컨테이너 */}
                <div className="store_container">
                  {/* 매장 정보 */}
                  <div className="store_info" id="store_info">
                    {store === 'hapjung' ? (
                      <StoreInfoHapjungItem store={store} />
                    ) : store === 'daejeon' ? (
                      <StoreInfoDaejeonItem store={store} />
                    ) : store === 'gwangju' ? (
                      <StoreInfoGwangjuItem store={store} />
                    ) : store === 'busan' ? (
                      <StoreInfoBusanItem store={store} />
                    ) : null}
                  </div>

                  {/* 콜라보 카페 & 이벤트 */}
                  <div className="store_collabo" id="store_collabo">
                    {/* 타이틀 */}
                    <div className="store_con_tit">
                      <h2>콜라보 카페 & 이벤트</h2>
                      <div className="sub">
                        최고급 카페메뉴와 스페셜 한정굿즈로 나만의 특별함을
                        채워보세요!
                      </div>
                    </div>
                    {/* 카드 리스트 */}
                    <ul className="store_card_list">
                      <li className="store_card_item big_item">
                        <div className="inner_item">
                          {/* 콜라보 슬라이드 버튼 */}
                          {store === 'hapjung' || store === 'busan' ? (
                            <div className="collabo_slide_btn">
                              {bannerList
                                ? bannerList.map((i, index) => {
                                    return (
                                      <button
                                        key={index}
                                        type="button"
                                        onClick={() => this._onGoto(index)}
                                        className={
                                          slideIndex === index
                                            ? 'link active'
                                            : 'link'
                                        }
                                        data-slide="1"
                                      >
                                        카페 {index + 1}
                                      </button>
                                    );
                                  })
                                : null}
                            </div>
                          ) : null}

                          {/* 카드 내용 , 종료 off (콜라보 카페 cafe, 서울 합정점 su_hj, 대전 중앙로점 dj_ja, 광주 충장로점 gj_cj, 부산 서면점 bs_sm) / */}
                          <div className="store_card cafe">
                            {/* 콜라보 슬라이드 */}
                            <div className="store_collabo_slide">
                              {/* 콜라보 슬라이드 아이템 */}
                              <Slider
                                ref={(ref) => (this.slider = ref)}
                                {...settings}
                              >
                                {bannerList
                                  ? bannerList.length >= 0
                                    ? this._renderBanner()
                                    : null
                                  : null}
                              </Slider>
                            </div>
                          </div>
                        </div>
                      </li>

                      <li className="store_card_item sm_item">
                        <div className="inner_item">
                          {/* {topList
                            ? topList.length > 0
                              ? this._renderTopItem()
                              : null
                            : null} */}

                          {storeList ? this._renderStoryItem() : null}
                        </div>
                      </li>
                    </ul>
                  </div>

                  {/* 매장 소식 & 이야기 */}
                  <div className="store_newsStory" id="store_newsStory">
                    {/* 타이틀 */}
                    <div className="store_con_tit">
                      <h2>매장 소식 & 이야기</h2>
                      <div className="sub">
                        최고급 카페메뉴와 스페셜 한정굿즈로 나만의 특별함을
                        채워보세요!
                      </div>
                    </div>
                    {/* 카드 리스트 */}
                    <StoreInfoStoryList store={store} />
                  </div>

                  {/* 오시는 길 */}
                  <div className="store_location" id="store_location">
                    {/* 타이틀 */}
                    <div className="store_con_tit">
                      <h2>오시는 길</h2>
                      <div className="sub">
                        매장을 찾지 못하신 분은 고객센터로 연락 주시면 친절히
                        안내해 드리겠습니다.
                      </div>
                    </div>

                    <StoreInfoMap store={store} />
                  </div>
                </div>
              </div>
            </div>

            <Footer />
          </div>
          {/* /220109 store */}
          <div className="clear"></div>
        </div>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(React.memo(StoryInfo)));
